<template>
  <div class="box box-info">
    <a href="#" @click.prevent="exportCSV()" v-if="this.itemMasterLists.length > 0">
          <img src="../../../../static/img/excel.png"
               style="height: 3.5em;width: 3.5em;"/>
    </a>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
       
        <DataTable
          :value="itemMasterLists"
          :paginator="true" ref="po"
          :rows="100" :filters="filters"
          editMode="cell"
          :rowsPerPageOptions="[100,500,1000]"
          class="p-datatable-responsive p-datatable-gridlines"
        >
          <Column header="S.N">
            <template #body="sl">
              {{ sl.index + 1 }}
            </template>
          </Column>

          <Column headerStyle="width: 16em" header="Name" field="name" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
            </template>
          </Column>
          <Column header="Code" field="itemCode" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
            </template>
          </Column>

          <Column header="Unit" field="unitName" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['unitName']"/>
            </template>
          </Column>
          <Column header="Closing Stock" bodyStyle="text-align: right" :sortable="true" field="closingStock"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['closingStock']"/>
            </template>
          </Column>
          <Column header="In Stock" bodyStyle="text-align: right" :sortable="true" filterMatchMode="contains">
            <template #editor="slotProps">
              <InputText v-model="inStock" @change="updateStock(slotProps.data)"/>
            </template>
          </Column>
           <Column header="Size" >
            <template #body="slotProps">
          <Button class="p-button-raised p-button-success"
                            @click.prevent="openBasic(slotProps)"
                            icon="pi pi-eye"/>
            </template>
           </Column>
          <template #empty>No record found</template>
        </DataTable>
      </div>
    </div>
    <Dialog header="Size Details" :visible.sync="displayBasic"
                    :style="{width: '50vw', height:'20vw'}" :modal="true" :closable=false
                    :contentStyle="{'overflow': 'visible'}">
              <form>
                <div class="p-fluid p-formgrid p-grid p-mt-2">
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Size</label>
                    <Dropdown
                      v-model="sizeName"
                      :options="sizeLists"
                      optionLabel="label"
                      optionValue="value"
                      :filter="true"
                      placeholder="Select Size"
                      id="extraExpense"
                      :showClear="true"
                    />
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Color</label>
                    <Dropdown
                      v-model="colorName"
                      :options="colorLists"
                      optionLabel="label"
                      optionValue="value"
                      :filter="true"
                      placeholder="Select Size"
                      id="extraExpense"
                      :showClear="true"
                    />
                  </div>

                    <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Closing Stock</label>
                  <InputNumber disabled id="inQuantity" mode="decimal" onfocus="if (this.value === '0.00'){this.value = ''}"
                         v-model="quantity" :minFractionDigits="2" :maxFracionDigits="4"/>
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">In Qty</label>
                  <InputNumber id="quantity" mode="decimal" onfocus="if (this.value === '0.00'){this.value = ''}"
                         v-model="inQuantity" :minFractionDigits="2" :maxFracionDigits="4"/>
                  </div>
    
                  <div class="p-field p-col-12 p-md-1 p-mt-5">
                    <Button class="p-button-raised"
                             @click.prevent="addInventoryStockSize" :label="!editDto?'Add':'Update'"/>
                  </div>
                   <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button class="p-button-raised p-button-danger" v-if="editDto" @click="itemDTOreset"
                    label="Cancel"/>
          </div>
                </div>
              </form>
              <table class="table table-bordered" style="margin-top: 2em;border: 1px solid #c8c8c8;">
                <thead>
                <tr>
                  <th>S.N</th>
                  <th>Size</th>
                  <th>Color</th>
                  <th>Quantity</th>
                    <th>In Quantity</th>
                  <!-- <th>Amount</th> -->
                  <th>Action</th>
                </tr>
                </thead>
                <tbody v-for="(expense,index) in inventoryStockSizeList" :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ expense.size }}</td>
                   <td>{{ expense.color }}</td>
                  <td>{{ expense.quantity }}</td>
                   <td>{{ expense.inQuantity }}</td>
                  <!-- <td>{{ expense.extraExpenseAmt }}</td> -->
                  <td>
                    <Button class="p-button-raised p-button-success"
                            @click.prevent="editExtraExpensesDto(expense,index)"
                            icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-danger"
                            @click.prevent="removeExtraExpense(expense, index)"
                            icon="pi pi-trash"/>
                  </td>
                </tr>
                </tbody>
              </table>
              <template #footer>
                <Button class="p-button-raised p-button-rounded" @click.prevent="closeBasic" label="Save"/>
                <Button @click.prevent="closeBasic" class="p-button-raised p-button-danger"
                        label="Cancel"/>
              </template>
            </Dialog>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'

export default {
  name: 'ItemWiseStockMgmt',
  data() {
    return {
      dialogShow: false,
      editDto: false,
      itemId: '',
      index: '',
      displayBasic: false,
      sumInQty: 0,
      tempClosingStock: 0.0,
      editExtraExpenses: false,
      itemMasterId: '',
      sizeName: '',
      colorName: '',
      inventoryStockSizeList: [],
      quantity: 0,
      inQuantity: 0,
      loading: false,
      imageDialog: false,
      filters: {},
      sizeLists: [
      { label: 'S', value: 'S' },
      { label: 'M', value: 'M' },
      { label: 'L', value: 'L' },
      { label: 'XL', value: 'XL' },
      { label: 'XXL', value: 'XXL' },
      { label: 'XXXL', value: 'XXXL' },
      { label: '28', value: '28' },
      { label: '29', value: '29' },
      { label: '30', value: '30' },
      { label: '31', value: '31' },
      { label: '32', value: '32' },
      { label: '33', value: '33' },
      { label: '34', value: '34' },
      { label: '35', value: '35' },
      { label: '36', value: '36' },
      { label: '37', value: '37' },
      { label: '38', value: '38' },
      { label: '39', value: '39' },
      { label: '40', value: '40' },
      { label: '41', value: '41' },
      { label: '42', value: '42' },
      { label: '43', value: '43' }
      ],
      colorLists: [
      { label: 'Red', value: 'Red' },
      { label: 'Black', value: 'Black' },
      { label: 'White', value: 'White' },
      { label: 'Blue', value: 'Blue' },
      { label: 'Green', value: 'Green' },
      { label: 'Yellow', value: 'Yellow' },
      { label: 'Carbon Blue', value: 'Carbon Blue' },
      { label: 'Light jeans', value: 'Light jeans' },
      { label: 'Wash Jeans', value: 'Wash Jeans' },
      { label: 'Wash Black', value: 'Wash Black' },
      { label: 'Dark Blue', value: 'Dark Blue' }
      ],
      inStock: 0
    }
  },
  computed: {
    itemMasterLists() {
      return this.$store.state.itemMaster.itemMasterLists
    }
  },
  mounted() {
    this.itemMasterList()
    this.columnNames()
  },
  methods: {
    async itemMasterList() {
      await this.$store.dispatch('loadItemMasterList')
    },
    async updateStock(data) {
      if (this.inventoryStockSizeList.length > 0) {
        if (this.sumInQty !== parseFloat(this.inStock)) {
          // debugger
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'Size quantity and item quantity are not equal!',
            life: 10000
          })
          return
        }
      }
      let stock = {
        itemId: data.id,
        inStockQty: this.inStock,
        inventoryStockSizeList: this.inventoryStockSizeList
      }
      let resp = await this.$store.dispatch('posStockIn', stock)
      // debugger
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: 'Stock of Item ' + data.name + resp.data.message,
          life: 3000
        })
        this.itemMasterList()
      }
      this.inStock = 0
      this.inventoryStockSizeList = []
    },
    removeExtraExpense(data, index) {
      this.inventoryStockSizeList.splice(index, 1)
    },
    editExtraExpensesDto(data, index) {
      // this.resetExtraExpenses()
      this.sizeName = data.size
      this.colorName = data.color
      this.editExtraExpenses = true
      this.index = index
      this.inQuantity = data.inQuantity
      this.quantity = data.quantity
      this.editDto = true
    },
    addInventoryStockSize() {
      let item = {
        size: this.sizeName,
        color: this.colorName,
        quantity: this.quantity,
        inQuantity: this.inQuantity,
        itemMasterId: this.itemMasterId
      }
      if (!this.editDto) {
        this.inventoryStockSizeList.push({...item})
      } else {
        this.inventoryStockSizeList.splice(this.index, 1, {...item})
      }
      this.sizeName = ''
      this.colorName = ''
      this.quantity = 0
      this.inQuantity = 0
      this.editDto = false
    },
    itemDTOreset() {
      this.sizeName = ''
      this.sumInQty = ''
      this.colorName = ''
      this.quantity = 0
      this.editDto = false
      this.id = null
    },
    closeBasic() {
      this.displayBasic = false
      this.editExtraExpenses = false
      this.sumInQty = 0.0
      for (let i = 0; i < this.inventoryStockSizeList.length; i++) {
        this.sumInQty += this.inventoryStockSizeList[i].inQuantity
      }
    },
    openBasic(data) {
      this.inventoryStockSizeList = data.data.inventorySizeDetailsDTOList
      this.itemMasterId = data.data.id
      this.displayBasic = true
      this.sumInQty = 0
      this.tempClosingStock = data.data.closingStock
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Item List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'itemList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button,
    Dialog,
    Dropdown,
    InputNumber
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ItemWiseStockMgmt.vue?52128daf